module.exports = __webpack_public_path__ + "img/kongres1.3de228f6.jpg";